/**
 * Convert plain pasted text so line breaks survive Live Preview (HTML).
 * Enter in contentEditable creates <div>/<br>; paste often only inserts \n,
 * which the editor shows via white-space: pre-wrap but preview collapses.
 */
export const plainTextToEmailHtml = (text) => {
    const escaped = String(text || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

    return escaped.replace(/\r\n|\r|\n/g, "<br>");
};

/**
 * Paste handler for Simple Editor contentEditable.
 * Prefers plain text → HTML with <br>. Uses structured HTML only when it
 * already contains line-break tags.
 * @returns {boolean} true if paste was handled
 */
export const handleSimpleEditorPaste = (event, onAfterInsert) => {
    const clipboard = event.clipboardData;
    if (!clipboard) return false;

    const htmlClip = clipboard.getData("text/html") || "";
    const hasStructuredBreaks = /<(br|p|div|li|tr|h[1-6])\b/i.test(htmlClip);

    if (hasStructuredBreaks && htmlClip.trim()) {
        // Keep browser default for Word/docs-style HTML pastes.
        return false;
    }

    const plain = clipboard.getData("text/plain");
    if (plain == null || plain === "") return false;

    event.preventDefault();
    const fragment = plainTextToEmailHtml(plain);
    document.execCommand("insertHTML", false, fragment);
    onAfterInsert?.();
    return true;
};

/**
 * Paste into Raw HTML source editor: insert plain text only so markup stays
 * source text, then re-decorate {{parameterN}} widgets.
 * @returns {boolean} true if paste was handled
 */
export const handleRawHtmlSourcePaste = (event, onAfterInsert) => {
    const clipboard = event.clipboardData;
    if (!clipboard) return false;

    const plain = clipboard.getData("text/plain");
    if (plain == null || plain === "") return false;

    event.preventDefault();
    document.execCommand("insertText", false, plain);
    onAfterInsert?.();
    return true;
};
